import React, { Component } from 'react';
import { Link } from 'react-router';
import Button from '../../components/Button';

import bagBadge from '../../images/badges/bag.svg';
import computerBadge from '../../images/badges/computer.svg';
import creditCardBadge from '../../images/badges/creditcard.svg';
import Logo from '../../images/logo.png';

import Values from './Values';
import Footer from './Footer';

let values = [
  {
    className: '',
    header: 'Passionate about Product',
    imageUrl: bagBadge,
    description: 'Lorem ipsum dolor sit amet, conse ctetur adipiscing elit.'
  },
  {
    className: '',
    header: 'Believe in the Little Guys',
    imageUrl: computerBadge,
    description: 'Lorem ipsum dolor sit amet, conse ctetur adipiscing elit.'
  },
  {
    className: '',
    header: 'Love what We Do',
    imageUrl: creditCardBadge,
    description: 'Lorem ipsum dolor sit amet, conse ctetur adipiscing elit.'
  }
];

export default class About extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onApplyClick() {
    window.location.assign('mailto:careers@indigofair.com');
  }

  render() {
    let onApplyClick = this.onApplyClick.bind(this);

    return (
      <div className="about" id="about">
        <div className="header-wrapper">
          <div className="content">
            <div className="logo-wrapper">
              <Link to="/">
                <img src={Logo} role="presentation" />
              </Link>
            </div>
          </div>
        </div>
        <div className="preamble">
          <div>Empowering Local Retailers</div>
        </div>
        <div className="about-preamble">
          <p>Indigo Fair is on a mission to revolutionize the way retailers shop for their stores. We take all the pain out of buying for store owners. Retailers can come to Indigo Fair to find unique and exciting products from hundreds of makers all in one place. We have also created the first wholesale marketplace to offer free returns. Our goal is to make every item in your store a bestseller.</p>
          <blockquote className="hidden">“At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentim voluptatum deleniti  corrupti quos dolores et quas molestias. Lorem ipsum spiritus.”</blockquote>
        </div>
        <Values values={values} className="hidden" />
        <div className="full-block">
          <div>We’re here to help you discover the perfect products for your store.</div>
        </div>
        <div className="jobs">
          <div>Interested in joining the team?</div>
          <Button onClick={onApplyClick}>Apply</Button>
        </div>
        <Footer />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Home/About.js
 **/